import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import { useInstance, createRef } from 'intact-react';
/**
 * don't trigger focusout event when layer is showing,
 * only trigger focusout when it is hidden to make FormItem to validate it
 * #449
 */
export function useFocusout() {
  var instance = useInstance();
  var triggerRef = createRef();
  instance.on('hide', function () {
    // add _dispatch true to let Input knowns ignore this event
    // and don't endInput, #523
    dispatchEvent(triggerRef.value, 'focusout', {
      _dispatch: true
    });
  });
  function onFocusout(e) {
    instance.trigger('focusout', e);
    if (instance.get('show')) {
      e.stopPropagation();
    }
  }
  return {
    onFocusout: onFocusout,
    triggerRef: triggerRef
  };
}
function dispatchEvent(target, eventName, options) {
  var event;
  if (document.createEvent) {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  } else if (typeof CustomEvent !== 'undefined') {
    event = new CustomEvent(eventName);
  }
  _Object$assign(event, options);
  target.dispatchEvent(event);
}